import styled from "styled-components";

import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  & > div:first-child {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  & > button {
    height: min-content !important;
    width: max-content !important;
    margin-top: 20px !important;
    min-width: max-content !important;
  }

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

export const Label = styled.label`
  color: ${props => `${props.color}`};

  font-size: 13px;
  font-family: "Montserrat";
  font-weight: 700;
`;
